module.exports = __webpack_public_path__ + "static/img/4-05.f6866d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/4-05.png
// module id = 28
// module chunks = 0